import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const gitHash = (process.env.REACT_APP_GIT_SHA || '').slice(0, 6);
  const buildLabel = gitHash ? `Build ${gitHash}` : 'Build unavailable';
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: { xs: 2, md: 4 },
        backgroundColor: theme => theme.palette.grey[100],
        borderTop: theme => `1px solid ${theme.palette.grey[300]}`,
        position: 'relative',
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: 'center', textTransform: 'none' }}
      >
        © {currentYear} Veravas, Inc. All rights reserved. VeraBIND (TM) is a trademark of Veravas, Inc. |{' '}
        <MuiLink
          href="mailto:info@veravas.com"
          sx={{
            color: '#0B6D6D',
            fontWeight: 600,
            '&:hover': { color: '#084F4F' },
          }}
        >
          info@veravas.com
        </MuiLink>{' '}
        |{' '}
        <MuiLink
          href="https://www.veravas.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: '#0B6D6D',
            fontWeight: 600,
            '&:hover': { color: '#084F4F' },
          }}
        >
          www.veravas.com
        </MuiLink>
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          position: 'absolute',
          right: 16,
          bottom: 8,
          textTransform: 'none',
        }}
      >
        {buildLabel}
      </Typography>
    </Box>
  );
}
